module.exports = __webpack_public_path__ + "static/img/2s-info-b6.238b36c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/2s-info-b6.jpg
// module id = Quej
// module chunks = 0